// src/components/cards/OptionCard.jsx
import React from 'react';
import FeatureList from '../common/FeatureList';

const OptionCard = ({
  title,
  description,
  icon,
  buttonText,
  buttonGradient,
  features,
  iconBgColor,
  iconTextColor,
  onSelect,
}) => (
  <div
    className="group bg-white rounded-2xl border border-gray-100 shadow-md hover:shadow-xl transition-all duration-300 overflow-hidden flex flex-col cursor-pointer"
    onClick={onSelect}
  >
    {/* Top accent bar */}
    <div className={`h-1 w-full ${buttonGradient}`} />

    <div className="flex flex-col flex-1 p-5 sm:p-6 gap-4">

      {/* Icon + title + description */}
      <div className="flex flex-col items-center text-center gap-3">
        <div className={`w-14 h-14 sm:w-16 sm:h-16 ${iconBgColor} rounded-2xl flex items-center justify-center flex-shrink-0 shadow-sm group-hover:scale-105 transition-transform duration-300`}>
          <span className={iconTextColor}>{icon}</span>
        </div>
        <div>
          <h2 className="text-lg sm:text-xl font-bold text-gray-900">{title}</h2>
          <p className="text-xs sm:text-sm text-gray-500 mt-1 leading-relaxed">{description}</p>
        </div>
      </div>

      {/* Features */}
      <div className="flex-1">
        <FeatureList features={features} />
      </div>

      {/* CTA button */}
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); onSelect?.(); }}
        className={`w-full ${buttonGradient} text-white font-semibold text-sm sm:text-base py-2.5 sm:py-3 px-4 rounded-xl text-center transition-opacity hover:opacity-90 active:opacity-80 shadow-sm mt-auto`}
      >
        {buttonText}
      </button>
    </div>
  </div>
);

export default OptionCard;